// extracted by mini-css-extract-plugin
export default {"cardContainer":"block_cardContainer__1Yf35"};